import { render, staticRenderFns } from "./helpGetBoxs.vue?vue&type=template&id=89ad9306&scoped=true"
import script from "./helpGetBoxs.vue?vue&type=script&lang=js"
export * from "./helpGetBoxs.vue?vue&type=script&lang=js"
import style0 from "./helpGetBoxs.vue?vue&type=style&index=0&id=89ad9306&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ad9306",
  null
  
)

export default component.exports